import { createContext, useContext } from 'react'
import type { ReactNode, RefObject } from 'react'
import { useIframeVisibilityState } from './iframe-visibility-context.hook'

interface IframeVisibilityContextValue {
  isPayInOpen: boolean
  setPayInOpen: (open: boolean) => void
  closeHandlerRef: RefObject<(() => void) | undefined>
}

const defaultRef = { current: undefined }

const IframeVisibilityContext = createContext<IframeVisibilityContextValue>({
  isPayInOpen: false,
  setPayInOpen: () => {},
  closeHandlerRef: defaultRef,
})

export function IframeVisibilityProvider({
  children,
}: {
  children: ReactNode
}) {
  const { isPayInOpen, setPayInOpen, closeHandlerRef } =
    useIframeVisibilityState()
  return (
    <IframeVisibilityContext.Provider
      value={{ isPayInOpen, setPayInOpen, closeHandlerRef }}
    >
      {children}
    </IframeVisibilityContext.Provider>
  )
}

export function useIframeVisibility() {
  return useContext(IframeVisibilityContext)
}
